module.exports = __webpack_public_path__ + "static/img/IMG_20160224_155339.18eec534.jpg";